
import ApiClient from "../api-client"
import useStore from "../../hooks/useStore";

const sleep = ms =>
    new Promise(resolve => {
        setTimeout(() => {
            resolve();
        }, ms);
    });

const optionsPerPage = 10;
var _data = [];
var countData=0;
const loadCustomerOptions = async (search, page, props) => {
    var companyId = useStore.getState().selectedCompany.id;

    var sortBy = null;
    var order = "asc";
    var simpleColumnFilters ;
    if(search){
        simpleColumnFilters = [{
            column: "name",
            filter: search,
            filterType:"text",
            searchOperator: "contains"
        },
        {
            column: "taxpayerId",
            filter: search,
            filterType:"text",
            searchOperator: "contains"
        }]
    }
    var object = {
        "quickSearch": "",
        "pageNo": page,
        "sortBy": sortBy,
        "order": order,
        "pageSize":optionsPerPage,
        "simpleColumnFilters": simpleColumnFilters
    }
   
    let filteredOptions;
    let hasMore;
    let slicedOptions;
    const result = await ApiClient.getCompanyCustomersPage(companyId, object, props.selectedInvoiceType.myDataInvoiceType);

    var data = result.data.objectList;


    if(page==1){
        countData=data.length;
    }
    else{
        countData+=data.length;
    }


    _data = [];
    data.forEach(element => {

        var _d = {
            taxpayerId: element.taxpayerId,
            label: element.name,
            value: element.id,
            model: element
        }
        _data.push(_d);
    });


    // if (!search) {
    //     filteredOptions = _data;
    // } else {
    //     const searchLower = search.toLowerCase();

    //     filteredOptions = _data.filter(({ label }) =>
    //         label.toLowerCase().includes(searchLower)
    //     );
    // }

    hasMore = Math.ceil(countData / optionsPerPage) >= page;
    // slicedOptions = _data.slice(
    //     (page - 1) * optionsPerPage,
    //     page * optionsPerPage
    // );

    return {
        options: _data,
        hasMore
    };
};

export default loadCustomerOptions;
